class Navbar {
  constructor (el) {
    this.el = el
    this.burger = el.querySelector('.js-navbar-burger')
    this.close = el.querySelector('.js-navbar-close')
    this.menu = el.querySelector('.js-navbar-menu')
    this.searchBtn = el.querySelectorAll('.js-navbar-search-btn')
    this.search = el.querySelector('.js-navbar-search')
    this.searchField = this.search.querySelector('input')
    this.arrow = this.el.querySelectorAll('.js-navbar-arrow')
    this.isMenuOpen = false
    this.isSearchOpen = false

    this.initDefaults()
  }

  initDefaults () {
    this.initEvents()
  }

  initEvents () {
    this.burger.addEventListener('click', e => this.menuOpen(e))
    this.close.addEventListener('click', e => this.menuClose(e))
    this.searchBtn.forEach(el => {
      el.addEventListener('click', e => this.searchToggle(e))
    });
    this.searchField.addEventListener('input', e => this.showSearchResults(e))
    this.arrow.forEach(el => {
      el.addEventListener('click', e => this.onArrowClick(e))
    })
    document.addEventListener('click', e => this.clickOut(e))
    window.addEventListener('resize', e => this.onResize(e))
  }

  onResize (e) {
    if (window.innerWidth > 1279) {
      if (this.isMenuOpen) {
        this.menuClose(e)
        this.searchClose()
      }
    }
  }

  menuOpen (e) {
    e.preventDefault()

    this.isMenuOpen = true

    document.body.classList.add('block-scroll')

    this.burger.classList.add('active')
    this.menu.classList.add('active')
  }

  menuClose (e) {
    e.preventDefault()

    this.isMenuOpen = false

    document.body.classList.remove('block-scroll')

    this.burger.classList.remove('active')
    this.menu.classList.remove('active')
    setTimeout(() => {
      this.searchClose()
      this.menu.classList.remove('search')
    }, 300)

  }

  searchToggle (e) {
    e.preventDefault()

    this.searchBtn.forEach(el => {
      el.classList.toggle('active')
    })
    
    this.search.classList.toggle('open')
    this.search.classList.remove('active')
    
    if (window.innerWidth < 1280) {
      if (this.isMenuOpen) {
        this.menu.classList.toggle('search')
      }
      else if (!this.isMenuOpen && !this.isSearchOpen) {
        this.menu.classList.add('search')
        this.menuOpen (e)
      }
    }
    
    this.isSearchOpen = !this.isSearchOpen
  }

  searchClose () {

    this.isSearchOpen = false

    this.searchBtn.forEach(el => {
      el.classList.remove('active')
    })

    this.search.classList.remove('open')
    this.search.classList.remove('active')
  }

  showSearchResults (e) {
    this.search.classList.add('active')
  }

  clickOut (e) {
    if ( !$(this.menu).is(e.target) && $(this.menu).has(e.target).length === 0 && !$(this.searchBtn).is(e.target) && $(this.searchBtn).has(e.target).length === 0 ) {
      this.searchClose()
    }
  }

  onArrowClick (e) {
    e.preventDefault()
    const $target = $(e.currentTarget)
    const $parent = $target.parents('.navbar__item')
    const $items = $(this.el).find('.navbar__item')
    const $sublist = $(this.el).find('.navbar__sublist')
    const $targetSublist = $target.next('.navbar__sublist')

    if ($parent.hasClass('active')) {
      $parent.removeClass('active')
      $targetSublist.slideUp(300)
    } else {
      $items.removeClass('active')
      $parent.addClass('active')
      $sublist.slideUp(300)
      $targetSublist.slideDown(300)
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.js-navbar')

  if (el) {
    new Navbar(el)
  }
})